export default {
  header: {},
  body: {
    headline: 'Server Error!',
    paragraphs: [
      {
        paragraphType: 'text',
        text: `
          <span>
            <p>Entschuldigen Sie, es ist ein Fehler aufgetreten. Wir arbeiten dran!</p>
            <p>Bitte versuchen Sie es auf unserer <a href="/">Startseite</a> oder später noch einmal.</p>
            <p>Ihr Service-Team</p>
          </span>
        `
      }
    ]
  },
  pageMeta: {},
  metaData: {}
}
